import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { useDirtyStore } from '@/modules/shared/stores/dirtyStore'
import { UnsavedChangesPrompt } from '@/modules/shared/hooks/useUnsavedChanges'

export const DirtyGuard: React.FC = () => {
  const isDirty = useDirtyStore((s) => s.isDirty)
  const setDirty = useDirtyStore((s) => s.setDirty)
  const { pathname } = useLocation()

  React.useEffect(() => {
    setDirty(false)
  }, [pathname, setDirty])

  return <UnsavedChangesPrompt when={isDirty} />
}
